import { hasSlipMark, slipMarkLabel, SLIP_MARK_PLAIN } from "@ub/shared/slipMark";
import css from "./SlipMark.module.css";

/**
 * Особая отметка премии или штрафа в расчётке (26.10.2026, владелец: «…возможность это добавление как-то особо
 * отмечать в расчётке»). Плашка «★ подпись» и выделение строки — в цвете самой строки (премии синий, штрафы красный,
 * канон цветов): отметка — это форма (звезда, рамка, свечение), а не новый цвет. Везде, где видна строка премии или
 * штрафа: лента HR, кабинет оператора, «Зарплаты», расчётный лист; картинка расчётки рисует то же (oo/payslip.ts).
 */
export type SlipTone = "bonus" | "pen";

export function SlipMarkTag({ mark, tone }: { mark: unknown; tone: SlipTone }) {
  if (!hasSlipMark(mark)) return null;
  const label = slipMarkLabel(mark);
  return (
    <span className={`${css.tag} ${tone === "pen" ? css.pen : css.bonus}`} title="Особая отметка в расчётке">
      {SLIP_MARK_PLAIN}{label ? ` ${label}` : ""}
    </span>
  );
}

/** Строка с отметкой переносится (ревью 26.10: в кабинете длинная подпись в однострочной ячейке прятала «Премия · за что»). */
export const slipWrapClass = (mark: unknown): string => (hasSlipMark(mark) ? css.wrap ?? "" : "");

/** Класс выделенной строки (рамка и свечение в цвете строки); без отметки — пусто. */
export const slipRowClass = (mark: unknown, tone: SlipTone): string =>
  hasSlipMark(mark) ? (tone === "pen" ? css.rowPen : css.rowBonus) ?? "" : "";
